import React, { useState, useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"
import Box from "@mui/material/Box"
import { Link } from "react-router-dom"
import {
    CHeader,
    CHeaderBrand,
    CImage,
} from "@coreui/react"
import logo from "src/assets/logo.png"
import { ChevronLeft, Search, HomeOutlined, MoreHoriz } from "@mui/icons-material"
import { Tab, Tabs } from "@mui/material"

export const ProductHeader = ({ onBack, onMore, onTabChange }) => {
    const [value, setValue] = useState(0);
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
    
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    
    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return (
        <CHeader position="sticky" className="product-header-div border-bottom-0">
            <Box className="product-header-inner-div d-flex" sx={{
                backgroundColor: "#ffffff",
                width: "100%",
                paddingLeft: "10px",
                paddingRight: "10px",
            }}>

                <Box onClick={() => {
                    onBack();
                }}>
                    <ChevronLeft color="#000" className="product-chevron-icon" />
                </Box>

                <CHeaderBrand href="#" aria-label="header brand">
                    <CImage fluid src={logo} alt="header logo" className="header-logo" />
                </CHeaderBrand>

                <Box sx={{
                    width: "100%"
                }}>
                    <Box className="d-flex justify-content-end">
                        <Link
                            to="/search"
                            className="search-icon-div text-decoration-none"
                            style={{
                                color: "#000000",
                                position: "relative",
                            }}
                        >
                            <Search className="search-icon" />
                        </Link>

                        <Link
                            to="/"
                            className="home-icon-div text-decoration-none"
                            style={{
                                color: "#000000",
                                position: "relative",
                            }}
                        >
                            <HomeOutlined className="home-icon" />
                        </Link>

                        <Link
                            onClick={() => {
                                onMore();
                            }}
                            className="more-icon-div text-decoration-none"
                            style={{
                                color: "#000000",
                                position: "relative",
                            }}
                        >
                            <MoreHoriz className="more-icon" />
                        </Link>
                    </Box>
                </Box>
            </Box>
            {scrollPosition !== 0 && (
                <Box className="product-tab-inner-div">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="fullWidth"
                        aria-label="basic tabs example"
                        className="product-tabs"
                        TabIndicatorProps={{
                            style: {
                                height: 3,
                                backgroundColor: "#000000"
                            }
                        }}
                    >
                        <Tab label="Overview" {...a11yProps(0)} onClick={() => {
                            onTabChange(0);
                        }} />
                        <Tab label="Details" {...a11yProps(1)} onClick={() => {
                            onTabChange(1);
                        }} />
                        <Tab label="Recommend" {...a11yProps(2)} onClick={() => {
                            onTabChange(2);
                        }}/>
                    </Tabs>
                </Box>
            )}
        </CHeader>
    )
}

export default ProductHeader
